(() => {
  if (window.foodchainFeedbackUploadLabels) return;
  window.foodchainFeedbackUploadLabels = true;

  const names = new WeakMap();
  const roots = new WeakSet();
  let nextId = 0;

  function labelUploads(root) {
    root.querySelectorAll('input[type="file"]').forEach((input) => {
      const name = input.getAttribute('aria-label')?.trim() || names.get(input);
      if (!name) return;
      names.set(input, name);

      if (!input.id) {
        do {
          input.id = `FoodchainFeedbackUpload-${++nextId}`;
        } while (root.querySelectorAll(`[id="${input.id}"]`).length > 1);
      }

      const labels = Array.from(input.labels || []);
      let label = labels.find((element) => element.textContent.trim()) || labels[0];
      if (!label) {
        label = document.createElement('label');
        label.htmlFor = input.id;
        input.before(label);
      }

      let text = label.querySelector('[data-fc-upload-label]');
      if (text || !label.textContent.trim()) {
        if (!text) {
          text = document.createElement('span');
          text.dataset.fcUploadLabel = '';
          text.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);clip-path:inset(50%);white-space:nowrap;border:0;font-size:14px;line-height:normal;';
          label.append(text);
        }
        if (text.textContent !== name) text.textContent = name;
      }

      // Remove the redundant ARIA name only after a native label is associated.
      if (Array.from(input.labels || []).some((element) => element.textContent.trim())) {
        input.removeAttribute('aria-label');
      }
    });
  }

  function applyFormColors(root) {
    if (!root.host.closest('[data-forms-id="forms-root-1133933"], [data-forms-id="forms-root-1133988"]')) return;
    if (root.querySelector('style[data-fc-feedback-colors]')) return;

    const style = document.createElement('style');
    style.dataset.fcFeedbackColors = '';
    style.textContent = `
      :host {
        --body-text-color: #000 !important;
        --heading-text-color: #000 !important;
        --link-text-color: #000 !important;
        --forms-accent-color: #000 !important;
        --form-text-color: #000 !important;
        --form-placeholder-color: #000 !important;
        --button-text-color: #000 !important;
        --button-background-color: #fff !important;
        --container-background-color: #fff !important;
        --form-background-color: #fff !important;
        color: #000;
        background-color: #fff;
      }
      a, a:link, a:visited, a:hover, a:focus, a:active {
        color: #000 !important;
        background-color: #fff !important;
        text-decoration: underline;
      }
      a:focus-visible {
        outline: 2px solid #000;
        outline-offset: 3px;
      }
      table, th, td {
        color: #000 !important;
        background-color: #fff !important;
        border-color: #cba058 !important;
      }
    `;
    root.append(style);
  }

  function connectForms() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || roots.has(root)) return;
      roots.add(root);
      const observer = new MutationObserver(() => {
        applyFormColors(root);
        labelUploads(root);
      });
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label', 'id', 'for'],
      });
      applyFormColors(root);
      labelUploads(root);
    });
  }

  customElements.whenDefined('shopify-forms-embed').then(connectForms);
  const observer = new MutationObserver(connectForms);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  connectForms();
})();
